<template>
  <div>
    <div class="edu_banner"></div>
    <div class="edu_con">
      <dl class="color_a">
        <dt><img src="@/assets/images/edu_icon_a.png" width="76" height="76" /></dt>
        <dd>
          <h3>报名</h3>
          <p>学员在线报名填写报名信息，方便快捷。时间自由掌控，课程自由选择。</p>
        </dd>
      </dl>

      <dl class="color_b">
        <dt><img src="@/assets/images/edu_icon_b.png" width="76" height="76" /></dt>
        <dd>
          <h3>培训计划</h3>
          <p>定制专属课程培训计划，课程学习课时内容自由选择，个性化定制。学员自由选择学习时间，更加合理，所学即所需。</p>
        </dd>
      </dl>

      <dl class="color_c">
        <dt><img src="@/assets/images/edu_icon_c.png" width="76" height="76" /></dt>
        <dd>
          <h3>学习</h3>
          <p>学员在线学习，讲师面对面指导教学。学习时间自由掌控，课程自由选择。课程结束后可重新学习机会。</p>
        </dd>
      </dl>

      <dl class="color_d">
        <dt><img src="@/assets/images/edu_icon_d.png" width="76" height="76" /></dt>
        <dd>
          <h3>发证</h3>
          <p>学员在线报名填写报名信息，方便快捷。时间自由掌控，课程自由选择。</p>
        </dd>
      </dl>

      <dl class="color_e">
        <dt><img src="@/assets/images/edu_icon_f.png" width="76" height="76" /></dt>
        <dd>
          <h3>考核</h3>
          <p>定制专属课程培训计划，课程学习课时内容自由选择，个性化定制。学员自由选择学习时间，更加合理，所学即所需。程自由选择。</p>
        </dd>
      </dl>

      <dl class="color_f">
        <dt><img src="@/assets/images/edu_icon_g.png" width="76" height="76" /></dt>
        <dd>
          <h3>考试</h3>
          <p>学员在线学习，讲师面对面指导教学。学习时间自由掌控，课程自由选择。课程结束后可重新学习机会。</p>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>

export default {
  components: { },
  data () {
    return {
    }
  },
  computed: {},
  created () {
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  destroyed () {
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/web_education.vue